export const DISMISSED_INCIDENT_IDS_STORAGE_KEY = "statusPageIncidentBannerDismissedIds";
